import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import updateSelectedWobs from './update-selected-wobs'

var LevitatedToggle = BootslideMenu.ToggleProperty.extend({
	property: {
		name: 'levitated',
		label: 'dashboards.keepInFront'
	},

	updateModel: function () {
		var newVal = !this.val()

		updateSelectedWobs(this.canvas, wob => {
			wob.levitate(newVal)
		})
	}
})

function createLevitatedMenu (widgetModel, canvas) {
	return {
		label: 'keepInFront',
		contentView: LevitatedToggle.extend({canvas: canvas}),
		model: widgetModel.wob
	}
}

export default createLevitatedMenu

createLevitatedMenu.__filename__ = 'dashboards/widgets/create-levitated-menu.js'
